import AWS from "aws-sdk";

const S3_BUCKET = process.env.REACT_APP_S3_BUCKET_NAME;
const REGION = process.env.REACT_APP_AWS_REGION;
// console.log("ENV VARIABLES:", process.env.REACT_APP_S3_BUCKET_NAME);

const s3 = new AWS.S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  endpoint:process.env.REACT_APP_AWS_END_POINT,
  region: REGION,
  s3ForcePathStyle:true,
  signatureVersion:'v4'
});

export { s3, S3_BUCKET };
